import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="py-12 md:py-20 px-5 md:px-8 relative overflow-hidden" data-id="element-53">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1a1f3a] rounded-full blur-[120px] opacity-50 -z-10 pointer-events-none" data-id="element-54"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-56">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-serif" data-id="element-57">
            Protocolo Silencio 11PM: El Método de 3 Minutos para "Apagar" el
            Zumbido y Dormir Profundo
          </h1>

          <h2 className="text-lg md:text-2xl text-gray-300 font-medium mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-58">
            Recupera tus noches y silencia la ansiedad del tinnitus sin aparatos
            costosos, sin fármacos y sin ruidos blancos que solo irritan tus
            oídos.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-2xl mx-auto mb-12" data-id="element-59">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent z-10 h-full w-full bottom-0" data-id="element-60"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9WRNLVyyLHnvGSLRJ1WJNU/Gemini_Generated_Image_4z6er44z6er44z6e.jpg" alt="Protocolo Silencio 11PM en tablet" className="w-full h-auto rounded-xl shadow-2xl border border-[#2a3150]" fetchPriority="high" data-id="element-61" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex justify-center" data-id="element-62">
          <a href="#comprar" className="bg-[#d4a853] hover:bg-[#e5b964] text-[#0a0e1a] font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-all duration-300 shadow-[0_0_25px_rgba(212,168,83,0.4)] transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto min-w-[280px]" data-id="element-63">
            Ver Protocolo
          </a>
        </motion.div>
      </div>
    </section>;
}